import React from 'react'
import { 
  useDispatch,
  useSelector 
} from 'react-redux'
import Box from '@mui/material/Box'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

import {
  selectFlashNotice,
  selectFlashAlert,
  clearFlashNotice,
  clearFlashAlert,
} from '../../redux/features/ui/uiSlice'

export default function StaticFlash() {

  const dispatch = useDispatch()
  const flashNotice = useSelector(selectFlashNotice)
  const flashAlert = useSelector(selectFlashAlert)

  const onNoticeClose = (evt) => {
    console.log("flash notice closed")
    dispatch(clearFlashNotice())
  }

  const onAlertClose = (evt) => {
    console.log("flash alert closed")
    dispatch(clearFlashAlert())
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        top: 36,
        horizontal: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        zIndex: 1400,
        boxShadow: 0,
      }}
    >
      {Boolean(flashNotice) && 
        <FlashMessage
          message={flashNotice}
          onClose={onNoticeClose}
          severity={'success'} 
        />
      }
      {Boolean(flashAlert) && 
        <FlashMessage
          message={flashAlert}
          onClose={onAlertClose}
          severity={'error'}
        />
      }
    </Box>
  )
}

function FlashMessage({ message, severity, onClose }){
 return (
    <Alert
      onClose={onClose}
      severity={severity}
      variant='standard'
      sx={{ width: '100%', whiteSpace: 'pre-line' }}
    >
      {message}
    </Alert>
  )
}